import CaseService from "../../Services/http/CaseService";
import { TShipmentItem } from "../../types/shipment.type";
import { TPackingList } from "../../types/PackingList.type";

// Function to retrieve unique shipment IDs from the shipment list
export const getUniqueShipmentIds = (shipmentList: TShipmentItem[]) => {
  return Array.from(new Set(shipmentList.map(item => item.shipment_id)));
};

// Function to prepare packing list data for each unique shipment ID
export const preparePackingListData = async (
  shipmentList: TShipmentItem[],
  packingList: TPackingList
) => {
  const uniqueShipmentIds = getUniqueShipmentIds(shipmentList);
  return Promise.all(
    uniqueShipmentIds.map(async shipment_id => {
      return await gatherDataForPdf(shipment_id, packingList);
    })
  );
};

// Function to gather all required data for a specific shipment ID to generate a PDF
export const gatherDataForPdf = async (
  shipment_id: string,
  packingList: TPackingList
) => {
  try {
    // Retrieve shipment details from the API based on shipment ID
    const shipmentDetails = await CaseService.getShipmentDetailsById(shipment_id);

    // Filter items specific to the current shipment ID
    const shipmentItems = await CaseService.getItemsByShipmentId(shipment_id);
    
    // Calculate total SKU count and unit total for the shipment
    const skuTotal = shipmentItems.length;
    const unitTotal = shipmentItems.reduce((total, item) => total + (item.quantity_shipped || 0), 0);
    
    // Return all gathered data as a structured object for PDF generation
    return {
      shipment_id,
      packingList,
      ...shipmentDetails,
      skuTotal,
      unitTotal,
      shipmentItems,
    };
  } catch (error) {
    console.error(`Error gathering data for shipment ID ${shipment_id}:`, error);
    return null;
  }
};

